var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:`canvas_${_vm.canvasKey}`,attrs:{"id":`canvas_${_vm.canvasKey}`,"width":_vm.canvasWidth,"height":_vm.size.long / this.drawScale + 88}})])
}
var staticRenderFns = []

export { render, staticRenderFns }